<template>
  <div class="crudblock">
    <avue-crud
      :option="option"
      :data="data"
      v-model="form"
      ref="crud"
      :page.sync="page"
      :search.sync="form"
      @setCurrent="setCurrent"
      @selection-change="selectionChange"
      @search-reset="searchReset"
      @on-load="onLoad"
      @search-change="searchChange"
      @sort-change="sortChange"
    >
      <!-- <template slot="search" slot-scope="{ row, size }">
        <div class="block" style="margin-left:15px">
          <el-form-item label="模糊搜索">
            <el-input
              v-model="form.search"
              width="150px"
              placeholder="项目编号/项目名称/客户名称"
            ></el-input>
          </el-form-item>
        </div>
      </template> -->
      <template slot="searchMenu" slot-scope="{ row }">
        <el-button type="primary" @click="save(row)">保存</el-button>

        <el-button type="primary" @click="screen"
          ><a-icon type="filter" /> 高级筛选</el-button
        >
      </template>
      <!-- // -->
      <template slot="menuLeft">
        <el-button
          size="small"
          plain
          @click="exportShow"
          icon="el-icon-download"
          >导出数据</el-button
        >

        <el-button
          size="small"
          type="danger"
          plain
          @click="supplyStuff"
          :disabled="disabled"
          icon="el-icon-folder-add"
        >
          补充材料</el-button
        >
        <!-- <el-button
          @click="PackdownloadShow=true"
          type="primary"
          size="small"
          icon="el-icon-download"
          :disabled="disabledDownload"
          >打包下载</el-button
        > -->
        <Packdownload
          :disabledDownload="disabledDownload"
          :packdownid="selectionData.length==1?selectionData[0].id:''"
          :projectname="selectionData.length==1?selectionData[0].name:''"
        />

        <!-- <Packdownload
          v-if="scope.row.closeState == 3"
          :packdownid="scope.row.id"
          :projectname="scope.row.name"
        /> -->
      </template>
      <template slot="menuRight">
        <el-tooltip class="item" effect="dark" content="显隐" placement="top">
          <el-button
            icon="el-icon-s-operation"
            circle
            @click="operation"
          ></el-button>
        </el-tooltip>
      </template>
      <template slot="name" slot-scope="{ row }">
        <div class="project-name" @click="handleDetails(row.id)">
          {{ row.name }}
        </div>
      </template>
      <!-- <template slot-scope="scope" slot="menu">
        <div style="text-align: left">
          <el-button
            type="success"
            plain
            size="small"
            icon="el-icon-arrow-right"
            @click.stop="handleDetails(scope.row.id)"
            >详情
          </el-button>
          <Packdownload
            v-if="scope.row.closeState == 3"
            :packdownid="scope.row.id"
            :projectname="scope.row.name"
          />
        </div>
      </template> -->
    </avue-crud>
    <el-drawer
      title="高级筛选"
      :visible.sync="drawer"
      size="50%"
      custom-class="drawer_wrapper"
      :with-header="false"
    >
      <span>
        <div class="drawer_screen_wrapper">
          <div class="screen_header">
            <div class="screen_header_name">
              <a-icon type="filter" />
              高级筛选
            </div>
            <div class="screen_header_remarks" @click="drawer = false">
              <i class="el-icon-video-play"></i>
              收起
            </div>
          </div>
          <div class="screen_content">
            <avue-form
              :option="option"
              ref="formScreen"
              v-model="form"
              @submit="handleSearch"
              @reset-change="searchResetScreen"
            >
              <template slot="quota">
                <div class="form_slot">
                  <el-input-number
                    :controls="false"
                    v-model="form.quotaMin"
                    placeholder="开始数值"
                    style="width: 100%"
                  />
                  ~
                  <el-input-number
                    v-model="form.quotaMax"
                    :controls="false"
                    placeholder="结束数值"
                    style="width: 100%"
                  />
                </div>
              </template>
            </avue-form>
          </div>
        </div>
      </span>
    </el-drawer>
    

    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="false"
      :clear="false"
      @setPeople="setPeople"
    />
    <Options
      ref="Options"
      :plainOptions="showHide"
      :pageDataId="routerpath"
      @returnData="returnData"
    />
    <Reason ref="reasonblock" :passdata="passdata" @passcheck="passcheck" />
    <Verification ref="verif" @verificheckreturn="verificheckreturn" />
    <ExportData ref="exportData" @exportDownload="exportDownload" />
  </div>
</template>

<script>
import * as api from "@/api/zd/projectconclusion";
import { mapGetters } from "vuex";
import Verification from "./verificationVisible";
import { downLoadTemplate } from "@/router/downLoadTem";
import ExportData from "@/components/exportData/exportData";
import Options from "@/components/ShowHidden/showhidden";
import SelectPerson from "@/components/SelectPersonnel/person";
import Reason from "./reason.vue";
import Packdownload from "@/components/accessoriesother/packdownload";
export default {
  data() {
    return {
      routerpath: null,
      drawer: false,
      passdata: {
        id: "",
        advise: "",
      },
      shlb: 0,
      form: {},
      timepic: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      data: [],
      optionchange: {},
      selectionData: [],
      disabled: true,
      disabledDownload:true,
      PackdownloadShow:false
    };
  },
  computed: {
    ...mapGetters(["permission", "userInfo"]),
  },
  components: {
    ExportData,
    Verification,
    Reason,
    Options,
    SelectPerson,
    Packdownload,
  },
  watch: {
    files: {
      handler(newName, oldName) {
        if (oldName != undefined) {
          this.cloudTages(newName);
        }
      },

      immediate: true,
    },
    selectionData: {
      handler(data) {
        let list = data.filter((item) => {
          return (
            this.userInfo.user_id == item.managerUser && item.closeState == 3
          );
        });
        let downloadList = data.filter((item) => {
          return (
             item.closeState == 3
          );
        });
        this.disabledDownload = data.length == 0 || !(data.length==1&&downloadList.length==1);

        this.disabled = data.length == 0 || list.length != data.length;
      },
      deep: true,
    },
  },
  props: ["files", "option", "condition", "showHide"],
  created() {
    //  
    //  
    this.routerpath = this.$route.path;
  },
  activated() {
    this.onLoad(this.page);
  },
  methods: {
    //显示高级筛选抽屉
    screen() {
      this.form = { ...this.form, ...this.query };
      this.drawer = true;
    },
    //高级筛选
    handleSearch(form, done, loading) {
      this.form = { ...this.form, ...form };
      this.drawer = false;
      this.page.currentPage = 1;
     
      this.onLoad(this.page);
      done();
    },

    setCurrent(selection) {
      
    },
    //显隐
    operation() {
      let origencolum = this.showHide;
      this.$refs.Options.showmode();
    },

    returnData(data) {
     
      this.option.column = data;
    },

    //排序
    sortChange(val) {
      this.form.orderValue =
        val.order == "descending"
          ? "desc"
          : val.order == "ascending"
          ? "asc"
          : "";
      this.form.orderName = val.prop;
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },
    onLoad(page) {
      let data = JSON.parse(JSON.stringify(this.form));
      // this.condition!=undefined
      if (this.condition == "caiwu") {
        data.flagBookkeeping = 10;
        data.flagVerified = 10;
      }
      if (this.form.closeTime1 != undefined) {
        data.closeTimeMin = data.closeTime1[0];
        data.closeTimeMax = data.closeTime1[1];
      }
      delete data["closeTime1"];
      delete data["closeTime"];
      (data.firstNum = (page.currentPage - 1) * page.pageSize),
        (data.num = page.pageSize),
        api
          .projectgetCloseList(data)
          .then((res) => {
             
             
            this.auditlistNub = res.data.data.shlb;
            this.page.total = res.data.data.total;
            this.data = res.data.data.list;
          })
          .catch((res) => {
             
          });
    },
    searchChange(params, done) {
       
      this.form = {...this.form,...params};
      this.onLoad(this.page);
      done();
    },
    searchReset() {
      this.form = undefined;
      this.checkUserList = [];
      this.onLoad(this.page);
    },
    //高级筛选清空
    searchResetScreen() {
      this.$refs.crud.searchReset();
    },
    save(row) {
      this.$emit("rowdata", row);
    },
    cloudTages(data) {
       
      this.form = data;
      if (this.form.startDate) {
        this.timepic = [this.form.startDate, this.form.endDate];
      }
       
      this.searchChange(data);
    },
    handleDetails(id) {
       
      this.$router.push({ path: `/zd/projectconclusion/detail/${id}` });
    },
    handleEdit(id) {
       
      if (id == "-1") {
        this.$router.push({ path: `/zd/paymentmanage/add/-1` });
      } else {
        this.$router.push({ path: `/zd/paymentmanage/edit/${id}` });
      }
    },
    // //表格选中
    // selectone(selection, row) {
    //   this.selectionData = [];
    //   this.selectionData.push(row);
    // },
    // 表格全选 或 全部选中
    selectionChange(list) {
      this.selectionData = list;
    },
    toggleSelection(val) {
      this.$refs.crud.toggleSelection(val);
    },

    exportout() {
      let data = this.form;
      data.firstNum = "";
      data.num = "";
      delete data["$auditState"];
      delete data["$bankState"];
      let exceldata = this.daochu(data);
      this.$export.excel({
        title: "银行管理",
        columns: this.option.column,
        data: exceldata,
      });
    },
    daochu(data) {
      api.bankmessagegetList(data).then((res) => {
        return res.data.data.list;
      });
    },
    verification() {
      if (this.selectionData != []) {
        this.$refs.verif.showblock(this.selectionData);
      }

      //  
    },

    //核销回传
    verificheckreturn(data) {
       
      api
        .changeFlagVerified({
          id: data.id,
          flagVerified: 2,
          verificationTime: data.verificationTime,
        })
        .then((res) => {
           
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.toggleSelection(this.selectionData);
          this.onLoad(this.page);
        })
        .catch((res) => {
          this.$message({
            type: "info",
            message: res.data.msg,
          });
        });
    },

    //回退
    returnback() {
      if (this.selectionData != []) {
        this.passdata.id = this.selectionData[0].id;
        this.$refs.reasonblock.showblock("huitui");
      }
    },
    //记账
    bookkeeping() {
      this.$confirm("是否确定记账此数据, 操作确认?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api
          .changeFlagBookkeeping({
            id: this.selectionData[0].id,
            flagBookkeeping: 2,
          })
          .then((res) => {
            //  
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.toggleSelection(this.selectionData);
            this.onLoad(this.page);
          })
          .catch((res) => {
             
          });
      });
    },
    //反冲
    recoil() {
      if (this.selectionData != []) {
        this.passdata.id = this.selectionData[0].id;
        this.$refs.reasonblock.showblock("fanchong");
      }
    },

    // 原因填写返回
    passcheck(data, type) {
      if (type == "huitui") {
        api
          .changeFlagVerified({
            id: data.id,
            flagVerified: 1,
            verificationReason: data.advise,
          })
          .then((res) => {
            //  
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.toggleSelection(this.selectionData);
            this.onLoad(this.page);
          })
          .catch((res) => {
             
          });
      } else {
        api
          .changeFlagBookkeeping({
            id: data.id,
            flagBookkeeping: 1,
            bookkeepingReason: data.advise,
          })
          .then((res) => {
            //  
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.toggleSelection(this.selectionData);
            this.onLoad(this.page);
          })
          .catch((res) => {
             
          });
      }
    },

    handleDel(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api
            .deleteonlist({ id: id })
            .then((res) => {
               
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.onLoad(this.page);
            })
            .catch((res) => {
               
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //获取 人员名称
    getVisitPeople() {
      let people = this.checkUserList.map((item) => {
        return item.realName;
      });
      let ids = this.checkUserList.map((item) => {
        return item.id;
      });
      this.$nextTick(() => {
        this.form.managerUserName = people.join(",");
        this.form.managerUserIds = ids.join(",");
         
      });
    },
    // 人员选择插件打开
    selectPersonClick() {
      this.$refs.selectperson.showmode();
    },

    //人员 获取
    setPeople(val) {
      this.checkUserList = val;
      this.getVisitPeople();
    },
    exportShow() {
      this.$refs.exportData.showModel();
    },
    exportDownload(value) {
      let page = this.page;
      let data = {
        export: value.code,
      };
      let form = this.form;
      if (value.code == 1) {
        data = {
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          ...this.query,
          ...data,
          ...form,
        };
      } else if (value.code == 2) {
        delete form["firstNum"];
        delete form["num"];
        data = {
          ...this.query,
          ...data,
          ...form,
        };
      }
      downLoadTemplate("/api/zd/project/closeExport", data).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },

    //补充材料
    supplyStuff() {
      let self = this;
      const confirmText = [
        "是否确定补充材料？",
        "确定后，收尾状态将变为待提交",
      ];
      const newDatas = [];
      const h = this.$createElement;
      for (const i in confirmText) {
        newDatas.push(
          h(
            "p",
            {
              style:
                i == 0 ? "font-weight:700;color: #666666;font-size:16px;" : "",
            },
            confirmText[i]
          )
        );
      }
      this.$confirm("警告提示", {
        title: "提示",
        message: h("div", null, newDatas),
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let ids = self.selectionData.map((item) => {
            return item.id;
          });
          let res = await api.closeAuditReset(ids);
          if (res.data.code == 200) {
            self.$message({
              type: "success",
              message: "成功",
            });
            self.onLoad(self.page);
          }
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消",
          // });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.bankmanage {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .crudblock {
    background: #ffff;
    padding: 16px;
    border-radius: 4px;
  }
}
td div .bankstatediv {
  display: flex;
  flex-direction: row;
  align-items: center;

  .bankstatespan {
    display: inline-block;
    width: 8px;
    height: 8px;
    justify-content: center;
    background: red;
    margin-right: 5px;
    border-radius: 50%;
  }
  .bankstate_0 {
    background: #fec03d;
  }
  .bankstate_1 {
    background: #51d351;
  }
  .bankstate_2 {
    background: #ff7a8c;
  }
}
td div .contactName {
  display: flex;
  flex-direction: column;
}
.bankmanage .el-date-editor .el-range__icon {
  line-height: 24px;
}
.bankmanage .avue-crud .el-input__inner,
.bankmanage .avue-form .el-input__inner {
  line-height: 30px;
  height: 30px;
}
.project-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #409eff;
}
.project-name:hover {
  color: #409eff;
  cursor: pointer;
}
</style>
